import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form4-container" }
const _hoisted_2 = { class: "editor-layout" }
const _hoisted_3 = { class: "form-area" }
const _hoisted_4 = { class: "cover-uploader-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "uploaded-box"
}
const _hoisted_6 = { class: "image-error-slot" }
const _hoisted_7 = { class: "cover-mask" }
const _hoisted_8 = {
  key: 1,
  class: "upload-trigger-placeholder"
}
const _hoisted_9 = { class: "preview-area" }
const _hoisted_10 = { class: "mockup-phone" }
const _hoisted_11 = { class: "phone-screen" }
const _hoisted_12 = { class: "mock-nav" }
const _hoisted_13 = { class: "screen-hero" }
const _hoisted_14 = {
  key: 1,
  class: "hero-placeholder"
}
const _hoisted_15 = { class: "screen-body" }
const _hoisted_16 = { class: "screen-title" }
const _hoisted_17 = { class: "screen-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_PictureFilled = _resolveComponent("PictureFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "section-header" }, [
      _createElementVNode("h2", { class: "section-title" }, "景点背景与通关知识"),
      _createElementVNode("span", { class: "section-tip" }, "编排本关卡对应的景点历史或文化背景，右侧实时同步 App 端阅读视口")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "auto",
          "label-position": "top",
          ref: "ruleForm",
          "status-icon": "",
          class: "custom-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "景点名称 / 知识标题",
              prop: "attractionsTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.attractionsTitle,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.attractionsTitle) = $event)),
                  placeholder: "例如：滕王阁的建筑渊源",
                  maxlength: "40",
                  "show-word-limit": "",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "景点风貌图片",
              prop: "attractionsImage"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_upload, {
                    class: "attraction-uploader",
                    action: _ctx.UpdateApi,
                    "show-file-list": false,
                    "on-success": _ctx.handleAvatarSuccess,
                    "before-upload": _ctx.beforeAvatarUpload,
                    disabled: _ctx.allowUpload
                  }, {
                    default: _withCtx(() => [
                      (_ctx.form.attractionsImage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_el_image, {
                              src: _ctx.form.attractionsImage,
                              class: "cover-preview",
                              fit: "cover"
                            }, {
                              error: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_PictureFilled)
                                    ]),
                                    _: 1
                                  }),
                                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "加载失败", -1))
                                ])
                              ]),
                              _: 1
                            }, 8, ["src"]),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("span", {
                                class: "action-btn",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)), ["stop"])),
                                title: "删除并重新上传"
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Delete)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_el_icon, { class: "uploader-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            }),
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "trigger-text" }, "点击上传景点风貌图", -1)),
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "trigger-sub" }, "支持 4:3 | 1:1 | 3:4 / 小于 5MB", -1))
                          ]))
                    ]),
                    _: 1
                  }, 8, ["action", "on-success", "before-upload", "disabled"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "景点知识详细介绍",
              prop: "attractions"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.attractions,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.attractions) = $event)),
                  type: "textarea",
                  rows: 9,
                  placeholder: "请输入景点的历史典故、文化内涵或解谜相关的背景知识...",
                  maxlength: "1000",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "preview-header" }, [
          _createElementVNode("span", { class: "badge-dot" }),
          _createElementVNode("span", null, "移动端阅读呈现")
        ], -1)),
        _createElementVNode("div", _hoisted_10, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "phone-top-bar" }, [
            _createElementVNode("div", { class: "notch" })
          ], -1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ArrowLeft)
                ]),
                _: 1
              }),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "nav-title" }, "景点档案", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "nav-placeholder" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.form.attractionsImage)
                ? (_openBlock(), _createBlock(_component_el_image, {
                    key: 0,
                    src: _ctx.form.attractionsImage,
                    class: "hero-img",
                    alt: "Attraction Cover",
                    fit: "contain"
                  }, null, 8, ["src"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_PictureFilled)
                      ]),
                      _: 1
                    }),
                    _cache[8] || (_cache[8] = _createElementVNode("span", null, "景点插图预览", -1))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.form.attractionsTitle || "景点标题占位"), 1),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.form.attractions ||
                  "景点历史沿革、解说辞或文化常识将在此处完整展示，支持自动断行与上下滚动查看..."), 1)
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "screen-footer" }, [
              _createElementVNode("button", { class: "mock-next-btn" }, "已了解，继续探索")
            ], -1))
          ])
        ])
      ])
    ])
  ]))
}